<template>
  <div class="list_notifications container-inner py-30">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <message-area />
    <!-- Main container -->
    <nav class="level boder-sidebar nav-header">
      <!-- Left side -->
      <div class="level-left">
        <div class="level-item"><h5 class="c-text_title">お知らせ一覧</h5></div>
      </div>
      <!-- Right side -->
      <div class="level-right">
        <div class="level-item">
          <div class="field has-addons search-input">
            <p class="control" style="width: 208px;">
              <input
                v-model="keywords"
                class="input"
                type="text"
                placeholder=""
              />
            </p>
            <p class="control">
              <button
                class="button btn-search svg-icon"
                @click="searchNotifications"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fal"
                  data-icon="search"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  class="svg-inline--fa fa-search fa-w-16 fa-3x"
                >
                  <path
                    fill="currentColor"
                    d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"
                    class=""
                  ></path>
                </svg>
              </button>
            </p>
          </div>
        </div>
      </div>
    </nav>

    <div class="">
      <item-notification
        v-for="(item, index) in items"
        :item="item"
        :key="index"
        class="tile is-parent"
      />
    </div>

    <div id="loadMore" style="">
      <button class="button" @click="getNotifications(1)">
        {{ $t('C030_17') }}
      </button>
    </div>
  </div>
</template>
<style lang="scss" src="./list.scss">
</style>

<script>
import { Carousel, Slide } from 'vue-carousel';
import ItemNotication from '../item-notication/item-notication';
import { getNotificationList, searchNotification } from '../../../../services/notification.service';
import MessageArea from '@/components/common/message-area/message-area.vue';
import messageUtils from '../../../../utils/mixins/messageUtils';
import { dateFromUnix } from '../../../../utils/commonUtil';
export default {
  name: 'NotificationList',
  components: {
    Carousel,
    Slide,
    'message-area': MessageArea,
    'item-notification': ItemNotication
  },
  mixins: [messageUtils],
  data() {
    return {
      isSearch: false,
      keywords: '',
      readStatusSearch: -1,
      limit: 10,
      items: [],
      value: '',
      per_page: 1,
      per_page_bottom: 10
    };
  },
  mounted() {
    this.getNotifications();
  },
  methods: {
    searchNotifications() {
      this.isSearch = false;
      if (this.keywords.length > 1) {
        this.isSearch = true;
      }
      this.getNotifications();
    },
    async getNotifications(loadMore = null) {
      this.clearMessage();
      let searchFrom = new Date().getTime();
      if (loadMore) {
        const lastItem = this.items[this.items.length - 1];
        if (lastItem && lastItem.createdAt) {
          const time = lastItem.createdAt.seconds || lastItem.createdAt._seconds;
          searchFrom = time * 1000;
        }
      }

      this.loading++;
      const params = {
        readStatus: this.readStatusSearch,
        from: searchFrom,
        keyword: this.keywords.trim(),
        limit: this.limit
      };

      let response = null;
      if (this.isSearch) {
        response = await searchNotification(params);
      } else {
        response = await getNotificationList(params);
      }
      console.log(`list.vue - (130) - `, response);
      const { status, result } = response;
      if (!status) {
        this.updateMessage(status, result);
      } else {
        if (loadMore) {
          const currentItems = [...this.items];
          currentItems.push(...result.data);
          this.items = currentItems;
        } else {
          this.items = result.data;
          // if (result.data.length === 0) {
          //   this.updateMessage(0, { messageId: 'EA2022_Content' });
          // }
        }
      }
      this.loading--;
    }
  }
};
</script>
